<template>
    <div class="voucher">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                   <div class="searchCon clearfix">
                        <div class="left searchBtn" style="width:130px;">
                            <button type="button" @click="showUpBox"><i class="el-icon-plus"></i>添加代金券</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:14%;">代金券名称</th>
                                <th style="width:14%;">创建时间</th>
                                <th style="width:14%;">开始日期</th>
                                <th style="width:14%;">结束日期</th>
                                <th style="width:10%;">满值赠送</th>
                                <th style="width:10%;">使用金额</th>
                                <th style="width:10%;">面值</th>
                                <th style="width:14%;">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:couponList.length<10}">
                                    <tr v-for="item in couponList">
                                        <td style="width:14%;"><span v-text="item.couponName"></span></td>
                                        <td style="width:14%;"><span>{{item.addTime | numberToMonthDate('')}}</span></td>
                                        <td style="width:14%;"><span>{{item.startTime | numberToDate('')}}</span></td>
                                        <td style="width:14%;"><span>{{item.endTime | numberToDate('')}}</span></td>
                                        <td style="width:10%;"><span v-text="item.startAmount"></span></td>
                                        <td style="width:10%;"><span v-text="item.useAmount"></span></td>
                                        <td style="width:10%;"><span v-text="item.giveAmount"></span></td>
                                        <td style="width:14%;">
                                            <div v-if="item.id" class="btnInline">
                                                <el-button type="text" title="修改" @click="uploadCoupon(item)"><i class="iconfont icon-bianji"></i></el-button>
                                                <el-button type="text" title="删除" @click="delCoupon(item.id)"><i class="iconfont icon-icon1460188478041"></i></el-button>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:(curPage>0)}" @click="changePage(false)"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(curPage+1)"></span>
                                <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:((curPage+1)<totalPage)}" @click="changePage(true)"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right" v-text="'第 '+(curPage+1)+' / '+totalPage+' 页'"></div>
                        <div class="totalPage flex flex-align-center right" v-text="'共'+totalElements+'条'"></div>
                    </div>
                </div> -->
            </div>
        </div>
        <el-dialog
            :title="isChangeCoupon?'修改代金券':'添加代金券'"
            :visible.sync="addCouponBtn"
            size="tiny">
            <div>
                <div class="msg clearfix" @click="goodCheckArr=[]">
                    <div class="couponConBox left clearfix">
                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>代金券名称</span>
                            <input type="text" class="left itemInput" v-model="newCoupon.name" placeholder="请输入代金券名称" >
                        </div>

                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>满值赠送</span>
                            <input type="text" class="left itemInput" v-model="newCoupon.startAmount" placeholder="请输入金额" >
                            <span class="notice">用户消费满设定的金额才能赠送代金券</span>
                        </div>

                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>使用代金券所需金额</span>
                            <input type="text" class="left itemInput" v-model="newCoupon.useAmount" placeholder="请输入金额" >
                            <span class="notice">用户消费满设定的金额才能使用代金券</span>
                        </div>
                        
                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>代金券面值</span>
                            <input type="text" class="left itemInput" v-model="newCoupon.giveAmount" placeholder="请输入金额" >
                        </div>
                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>使用时间</span>
                            <!-- <span style="position:relative;">
                                <input type="tel" class="left itemInput" v-model="newCoupon.expireDays" placeholder="请输入过期时间" ><span class="left" style="position:absolute;right:10px;color:red;">天</span>
                            </span>
                            <span class="notice">注：抵用券可使用的天数（由创建时间开始算起）</span> -->
                           <!--  <el-date-picker
                              v-model="timeFromTo"
                              type="daterange"
                              value-format="yyyy/MM/dd"
                              range-separator="至"
                              start-placeholder="开始日期"
                              :picker-options="pickerOptions0"
                              end-placeholder="结束日期">
                            </el-date-picker> -->
                            <el-date-picker
                              v-model="startTime"
                              type="date"
                              :editable="false"
                              value-format="yyyy/MM/dd"
                              placeholder="选择开始日期">
                            </el-date-picker>
                            <span>至</span>
                            <el-date-picker
                              v-model="endTime"
                              value-format="yyyy/MM/dd"
                              type="date"
                              :editable="false"
                              placeholder="选择到期日期">
                            </el-date-picker>
                        </div>
                    </div>
                    
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addCouponBtn=false" class="cancel">取消</button>
                <button type="button" @click="saveCoupon" class="save">保存</button>
            </span>
        </el-dialog>
        <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId" @closeImgCrop="showCrop=false" @getCropImgBase="getCropImgBase"></img-crop>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import imgCrop from '@/components/imgCrop/imgCrop.vue';
    import {API_BASE_URL} from "./../../../urlConfig/index";
    export default{
        components: {imgCrop},
        props: ['pageSize','curStoreId'],
        data () {
            return {
                selectItem:null,
                isChangeCoupon:false,
                dialogVisible: false,
                addCouponBtn:false,//添加规则按钮
                couponList:[
                ],//规则列表
                rulesId:'',//规则id
                couponType:'GET_ITEM_FREE',
                couponTypeText: {
                    'GET_ITEM_FREE': '商品抵用券'
                },
                newCoupon: {
                   name:"",
                   startAmount:"",
                   useAmount:"",
                   giveAmount:"",
                   startTime:"",
                   endTime:""
                },
                shareable: 'OFF', // 是否可分享
                goodCheckArr: [], // 商品检索数组
                keyWords: '', // 商品检索关键字
                goodSearchBtn: true, // 控制商品检索请求
                curGoodIdx: 0, // 商品检索索引

                coverImgMaxSize: 200*1024, // 图片最大字节数
                oldImgBase64: '', // 原图base64
                showCrop: false, // 控制图片裁剪显示隐藏
                curCropW: 600, // 裁剪宽度
                curCropH: 600, // 裁剪高度
                infoload: false, // loading

                curPage: 0,//当前页，用于切换页码
                totalPage: 1,//总共页
                totalElements: 0,//总共条

                addCouponApiBtn: true, // 控制新增接口

                pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() < Date.now()-86400000;
                    }
                },
                timeFromTo: ['',''],
                startTime:'',
                endTime:''
            }
        },

        watch:{
            keyWords : function(val){
                if ( this.newCoupon.productName == this.keyWords ) {
                    this.goodCheckArr = [];
                    return;
                }
                this.goodSearch();
            },
            addCouponBtn(val){
                if(!val){
                    this.isChangeCoupon = false;
                }
            }
        },
        methods: {
            showUpBox(item){
                this.timeTo = '';
                this.timeFrom = '';
                this.addCouponBtn = true;
                this.newCoupon = {
                    id: this.$uuid.create(1).hex, // 新优惠券id
                    title: '', // 名称
                    notice: '1、每位会员每单限使用一张，不可叠加使用。 2、本券不可兑换现金且不退不换，不与其它活动同享，使用本券不提供发票。 3、由网管通过店员宝向顾客派发本券。 4、一切解释权归发行方所有', // 使用说明
                    description: '', // 详细说明
                    type: 'GET_ITEM_FREE', // 优惠券类型
                    productId: '', // 商品id
                    productName: '', // 商品名称
                    source: 'STORE', // 优惠券来源
                    storeId: this.curStoreId, // 店铺id
                    shareable: true, // 是否可分享
                    expireDays: 1, // 过期时间
                    logoURL: 'https://hxypic.oss-cn-hangzhou.aliyuncs.com/image/660e7964-7f08-11e7-b600-15739cd8b3d5/4db97466006a4e6daad1c71370ba8333.jpg', // 优惠券图片
                };
                this.keyWords = '';
                this.shareable = 'ON';
            },
            // 保存代金券
            saveCoupon: function () {

                if ( !this.newCoupon.name ) {
                    this.$message({
                        message: '请输入名称',
                        customClass: 'error'
                    })
                    return;
                }
                
                if ( !this.startTime ) {
                    this.$message({
                        message: '请选择代金券使用开始时间',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.endTime ) {
                    this.$message({
                        message: '请选择代金券过期时间',
                        customClass: 'error'
                    })
                    return;
                }
                if ( new Date(this.endTime).getTime()< new Date(this.startTime).getTime() ) {
                    this.$message({
                        message: '开始时间不能大于过期时间',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.addCouponApiBtn ) {
                    return;
                }
                this.addCouponApiBtn = false;
                let storeName = JSON.parse(sessionStorage.getItem("storeName"));
                if(!storeName){
                    this.$message({
                        message: '请重新登录后执行添加操作',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.isChangeCoupon){
                    let aNewCoupon = {
                        couponName:this.newCoupon.name,
                        startAmount:this.newCoupon.startAmount,
                        giveAmount:this.newCoupon.giveAmount,
                        useAmount:this.newCoupon.useAmount,
                        startTime: new Date(this.startTime).Format('yyyy-MM-dd'),
                        endTime: new Date(this.endTime).Format('yyyy-MM-dd'),
                        storeId:this.curStoreId,
                        storeName
                    };
                    this.$http.post('add-coupon', aNewCoupon).then((res)=>{
                        this.addCouponApiBtn = true;
                        this.addCouponBtn = false;
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        })
                        this.getCouponList();
                        return;
                    }).catch(()=>{
                        this.addCouponApiBtn = true;
                    })
                }else{
                  let aNewCoupon = {
                        couponName:this.newCoupon.name,
                        startAmount:this.newCoupon.startAmount,
                        giveAmount:this.newCoupon.giveAmount,
                        useAmount:this.newCoupon.useAmount,
                        startTime: new Date(this.startTime).Format('yyyy-MM-dd'),
                        endTime: new Date(this.endTime).Format('yyyy-MM-dd'),
                        id:this.selectItem.id
                    };
                    this.$http.post('update-coupon', aNewCoupon).then((res)=>{
                        this.addCouponApiBtn = true;
                        this.addCouponBtn = false;
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        })
                        this.getCouponList();
                        this.isChangeCoupon = false;
                        return;
                    }).catch(()=>{
                        this.addCouponApiBtn = true;
                    })  
                }
            },
            // 删除优惠券
            delCoupon(couponId){
                this.$confirm('此操作将删除该代金券, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                   this.$http.post('delete-coupon',{id:couponId}).then((res)=>{
                        this.$message({
                            message: '删除成功',
                            customClass: 'success'
                        });
                        this.getCouponList();
                    })
                }).catch(() => {});
            },
            // 修改优惠券
            uploadCoupon: function ( item ) {
                this.selectItem = item;
                if ( !item.startTime ) {
                    this.startTime = '';
                    this.endTime = '';
                } else {
                    this.startTime = new Date(item.startTime);
                    this.endTime = new Date(item.endTime);
                }
                this.newCoupon = {
                    name:item.couponName,
                    startAmount:item.startAmount,
                    giveAmount:item.giveAmount,
                    useAmount:item.useAmount,
                };
                this.addCouponBtn = true;
                this.isChangeCoupon = true;
            },
            //列表翻页
            changePage: function ( boo ) {
                if ( boo ) {
                    if ( (this.curPage + 1) >= this.totalPage ) {
                        return;
                    }
                    this.curPage++;
                } else {
                    if ( this.curPage <= 0 ) {
                        return;
                    }
                    this.curPage--;
                }
                this.getCouponList();
            },
            // 获取优惠券列表
            getCouponList: function () {
                this.$http.get('all-coupon?storeId='+this.curStoreId).then((res)=>{
                    this.couponList = res.data;
                }).catch(()=>{

                })
            },
            // 选择检索商品
            selSearchGood: function ( item ) {
                // console.log(item);
                this.newCoupon.productName = item.name;
                this.newCoupon.productId = item.id;
                this.keyWords = item.name;
                this.goodCheckArr = [];
            },
            // 商品检索
            goodSearch: function () {
                let val = this.keyWords;
                if ( !val ) {
                    this.goodCheckArr = [];
                    return;
                }
                if ( !this.goodSearchBtn ) {
                    return;
                }
                this.goodSearchBtn = false;
                this.$http.get('products/search?storeId='+this.curStoreId+'&q='+encodeURI(val)).then((res)=>{
                    this.goodCheckArr = res.data;
                    let btn = true;
                    for (var i = 0, len = this.goodCheckArr.length; i < len; i++) {
                        if ( this.keyWords == this.goodCheckArr[i].name ) {
                            this.newCoupon.productId = this.goodCheckArr[i].id;
                            this.newCoupon.productName = this.goodCheckArr[i].name;
                            btn = false;
                            break;
                        }
                    }
                    if ( btn ) {
                        this.newCoupon.productName = '';
                        this.newCoupon.productId = '';
                    }

                    setTimeout(()=>{
                        let that = this;
                        $('.goodCheckList li').hover( function () {
                            that.curGoodIdx = $(this).index()-1;
                        }, function () {
                            that.curGoodIdx = 0;
                        })
                    },0)
                    this.goodSearchBtn = true;
                }).catch(()=>{
                    this.goodSearchBtn = true;
                })
            },
            coverImg: function ( e ) {
                let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }

                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过200KB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过200KB',
                        customClass: 'error'
                    });
                    return false;
                }

                reader.onload = (function (file) {
                    return function (e) {
                        let that2 = this; // 缓存当前this
                        let img = new Image();
                        img.src= this.result;
                        img.onload=function(){
                            let imgBase64 = that2.result; //获得图片的base64的数据


                            // 判断是否是移动端设备
                            let sUserAgent = navigator.userAgent.toLowerCase();
                            let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                            let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                            let bIsMidp = sUserAgent.match(/midp/i) == "midp";
                            let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                            let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                            let bIsAndroid = sUserAgent.match(/android/i) == "android";
                            let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                            let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                                that.mobileUploadImg(imgBase64);
                            } else {
                                that.oldImgBase64 = imgBase64;
                                that.showCrop = true;
                            }
                        };
                        $('.pcImgFile').val('');
                        $('.mobileImgFile').val('');
                    };
                })(e.target.files[0]);
                reader.readAsDataURL(e.target.files[0]);
            },
            // 移动端上传图片
            mobileUploadImg: function (imgBase64) {
                this.infoload = true;
                this.$http.post(API_BASE_URL+'v1/image/json/upload?storeId='+this.curStoreId, {file: imgBase64}).then((res)=>{
                    this.newCoupon.logoURL = res.data.path;
                    this.infoload = false;
                }).catch(()=>{
                    this.infoload = false;
                });
            },
            // 获得裁剪后图片base64
            getCropImgBase: function ( imgUrl )　{
                this.newCoupon.logoURL = imgUrl;
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.couponList.push({})
            }
        },
        mounted: function () {
           this.getCouponList();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "./voucher.scss";
</style>



// WEBPACK FOOTER //
// voucher.vue?a50658dc